// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1H4Xo","sendOtp":"AuthorizeToLogin_sendOtp__3gVRw"};